import customerDetails from '../template/details/router/index';

export default [{
  path: '/customer/manage',
  name: 'customer-index',
  title: '顾客',
  component: () => import('@/views/customer/index')
}, {
  path: '/customer/noPhone',
  name: 'customer-noPhone',
  title: '无手机号顾客套餐',
  component: () => import('@/views/customer/noPhone')
}, ...customerDetails];
